module.exports = __webpack_public_path__ + "static/media/logoanai.547abcda.png";